import ReactGA from 'react-ga4';

export function Analytics(): void {
  const gaID = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const gaShouldTrack = !!Number(process.env.REACT_APP_TRACK);

  try {
    if (gaID && gaShouldTrack) {
      // initalize Google Analytics
      ReactGA.initialize(gaID);
    }
  } catch (error) {
    console.log(error);
  }
}
